import { CircularProgress, Typography } from '@mui/material'

const LazyLoader = () => {
  return (
    <div className="lazy-loader">
      <CircularProgress />
      <Typography variant="subtitle2" color="black" marginTop={5}>
        Loading...
      </Typography>
    </div>
  )
}

export default LazyLoader
